<template>
  <div class="status-update">
    <h2>{{ date ? date : '' }}</h2>
    <div v-html="messageHTML"></div>
  </div>
</template>

<script>
var markdown = require( "markdown" ).markdown

export default {
  name: 'Status',
  props: {
    date: String,
    message: String
  },
  computed: {
    messageHTML: function () {
      return markdown.toHTML(this.message)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
